import React from 'react'
import { Container, Col } from 'reactstrap'
import { Section, RowCentered } from '../../GlobalStyles'
import styled from 'styled-components'
import theme from '../../theme'
import { ButtonLink } from '../../common/Links'

export const ImageItem = styled.div`
  padding: 0 15px;
  flex: 0 1 14%;
  @media (max-width: 576px) {
    width: 100%;
    flex: 0 1 100%;
    text-align: center;
  }
`

export const VideoWrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
  margin-bottom: 20px;
  &:before {
    display: block;
    content: '';
    padding-top: 56.25%;
  }
  iframe {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`

const Video = ({ src }) => (
  <iframe
    allowFullScreen
    frameBorder='0'
    width='640'
    height='360'
    src={src}
    title='PGA Coaching Platform, hosted by Bill Cowher'
    webkitallowfullscreen='true'
    mozallowfullscreen='true'
  />
)

export const OverviewSection = () => {
  return (
    <Section size='0 0 100px'>
      <Container>
        <RowCentered>
          <VideoWrapper as={Col} xs='12' md='9' lg='7'>
            <Video src='https://player.vimeo.com/video/383367663' />
          </VideoWrapper>
        </RowCentered>
        <RowCentered>
          <ButtonLink
            url='https://pgacoach.lightspeedvt.com/'
            bgColor={theme.colors.gold}
            borderColor={theme.colors.gold}
            color={theme.colors.white}
            bgHoverColor={theme.colors.transparent}
            borderHoverColor={theme.colors.gold}
            hoverColor={theme.colors.gold}
            padding='8px 64px'
            btnStyle='secondary'
            aria-label='Get Started Here'
          >
            Log In to Get Started
          </ButtonLink>
        </RowCentered>
      </Container>
    </Section>
  )
}

export default OverviewSection
